import { Stack, Switch } from '@mui/material';
import { useCallback, useMemo } from 'react';

import { isOlderVersion } from '@/modules/common/helpers/config';
import { useConfig } from '@/modules/common/hooks';
import { UserPreferenceName } from '@modules/userPreferences';
import { useUpdateUserPreferences, useUserPreference } from '@/modules/userPreferences/hooks';

type Props = {
  onClose: () => void;
};

export const ShowReleaseMessage = ({ onClose }: Props) => {
  const { updateUserPreference } = useUpdateUserPreferences();
  const userPrefVersion = useUserPreference(UserPreferenceName.APP_STARTUP_MESSAGE_VERSION);
  const { app } = useConfig();

  const show = useMemo(
    () => isOlderVersion(userPrefVersion, app.version),
    [app.version, userPrefVersion],
  );

  const onModelChange = useCallback(() => {
    updateUserPreference(
      UserPreferenceName.APP_STARTUP_MESSAGE_VERSION,
      show ? app.version : '1.0.0',
    );
    if (!show) onClose();
  }, [updateUserPreference, show, app.version, onClose]);

  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <Switch onChange={onModelChange} checked={show} />
    </Stack>
  );
};
